var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3722(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3722",
    "data-name": "Group 3722",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2324",
    "data-name": "Rectangle 2324",
    width: 37,
    height: 34,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3721",
    "data-name": "Group 3721",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50598",
    "data-name": "Path 50598",
    d: "M16.083,18.25,13,21.333a2.167,2.167,0,0,1,0,3.083l4.625,4.625a2.167,2.167,0,0,1,3.083,0L33.042,16.708a2.167,2.167,0,0,1,0-3.083L28.417,9a2.167,2.167,0,0,1-3.083,0l-3.854,3.854",
    transform: "translate(-2.979 -2.063)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    y1: 2,
    x2: 2,
    transform: "translate(23 12)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    y1: 1,
    x2: 1,
    transform: "translate(15 21)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50599",
    "data-name": "Path 50599",
    d: "M11.937,14.875,5,21.812,16.563,33.375,37.375,12.563,25.813,1l-8.5,8.5",
    transform: "translate(-1.146 -0.229)",
    fill: "none",
    stroke: "#505050",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(17 15)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50600",
    "data-name": "Path 50600",
    d: "M0,18H2.313s1.734,2.313,3.854,2.313H9.25",
    transform: "translate(0 -4.125)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50601",
    "data-name": "Path 50601",
    d: "M18.5,7.625,15.417,4.542A3.515,3.515,0,0,0,12.333,3H0",
    transform: "translate(0 -0.688)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50602",
    "data-name": "Path 50602",
    d: "M11.4,7l6.167,6.167c1.42,1.419-2.116,3.628-4.232,1.935L11.4,13.167H9.083A2.87,2.87,0,0,1,6,10.083",
    transform: "translate(-1.375 -1.604)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3722);
export default __webpack_public_path__ + "static/media/Group3722.b0206d05b87fd683cd2365337cce8bdb.svg";
export { ForwardRef as ReactComponent };